export default __webpack_public_path__ + "static/media/hcs-logo-horiz-no-text.58b50963.svg";